import { IconButton } from '@material-ui/core';
import { Discord } from '../../assets/Discord';
import { Instagram } from '../../assets/Instagram';
import { Twitter } from '../../assets/Twitter';
import { Website } from '../../assets/Website';
import { Telegram } from '../../assets/Telegram';
import { t } from 'modules/i18n/utils/intl';
import { uid } from 'react-uid';
import { useSocialStyles } from './useSocialStyles';

interface ISocialProps {
  className?: string;
  twitter?: string;
  instagram?: string;
  discord?: string;
  website?: string;
  telegram?: string;
}

export const Social = ({
  className,
  twitter,
  instagram,
  discord,
  website,
  telegram
}: ISocialProps) => {
  const classes = useSocialStyles();

  const items = [
    {
      title: t('social.telegram'),
      href: telegram,
      icon: Telegram,
    },
    {
      title: t('social.instagram'),
      href: instagram,
      icon: Instagram,
    },
    {
      title: t('social.twitter'),
      href: twitter,
      icon: Twitter,
    },
    {
      title: t('social.facebook'),
      href: discord,
      icon: Discord,
    },
    {
      title: t('social.website'),
      href: website,
      icon: Website,
    },
    {
      title: t('social.website'),
      href: website,
      icon: Website,
    },
  ].filter(item => item.href);

  return (
    <div className={className}>
      <ul className={classes.list}>
        {items.map(({ title, href, icon: Icon }, i) => (
          <li className={classes.item} key={uid(i)}>
            <IconButton
              href={href as string}
              target="_blank"
              title={title}
              className={classes.icon}
            >
              <Icon />
            </IconButton>
          </li>
        ))}
      </ul>
    </div>
  );
};
